import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogService, FilterPipe, MAT_ICON, TOAST_STATE, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { GetProductsResponse } from '../../products/product-list/get-products.response';
import { Material } from '../../products/product-list/material.model';
import { AddDiscountpriceDialogComponent } from './adddiscountpricedialog/adddiscountpricedialog.component';
import { AddDiscountPriceDialogResult } from './adddiscountpricedialog/adddiscountpricedialogresult';
import { AddDiscountPriceRequest } from './adddiscountpricedialog/adddiscountpricerequest';
import { AddOnSalePeriodRequest } from './addonsaleperiodrequest';
import { AddOnSaleperiodResponse } from './addonsaleperiodresponse';
import { GetNotOnSaleableProductsResponse } from './getnotonsaleableproductsresponse';
import { OnSalePeriod } from './onsaleperiod';

@Component({
    selector: 'app-productsale',
    templateUrl: './addproductsonsale.component.html',
    styleUrls: ['./addproductsonsale.component.scss'],
    standalone: true,
    imports: [MatIconModule, ReactiveFormsModule, FormsModule, CommonModule, FilterPipe, RouterModule, TranslationPipe]
})
export class ProductsaleComponent implements OnInit {
    addOnSalePeriodUrl = '/admin/add-on-sale-period';
    getNotOnSaleableProductsUrl = '/admin/get-not-onsaleable-products';
    getProductsUrl = '/store/get-products';
    notOnSaleAbleProducts: Material[] = [];
    onSaleName = '';
    onSalePeriod: OnSalePeriod = {};
    products: Material[] = [];
    productSaleRequest: AddOnSalePeriodRequest = {};
    productsToSale: Material[] = [];
    saleForm?: FormGroup;
    searchText = '';
    storeBaseUrl = '';
    addDiscountPriceUrl = '/admin/add-discount-price';

    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _fb: FormBuilder,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        private _translateService: TranslationService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.createSaleForm();
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        }
        this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.getProductsUrl).subscribe((response) => {
            const products = response as GetProductsResponse;
            this.products = products.productList as Material[];

            this._apiRequestService
                .sendRequest<{}, GetNotOnSaleableProductsResponse>(this.storeBaseUrl, {}, true, this.getNotOnSaleableProductsUrl)
                .subscribe((answer) => {
                    this.notOnSaleAbleProducts = answer.notOnSaleableProductList as Material[];
                    //skipping notOnSaleableProducts from products
                    this.products = this.products.filter((p) => !this.notOnSaleAbleProducts.some((p2) => p2.routerLink === p.routerLink));

                    this.products.forEach((product) => {
                        if (!product.isAvailable) {
                            const index = this.products.indexOf(product);
                            this.products.splice(index, 1);
                        }
                    });
                });
        });
    }

    getNotOnSaleableProducts() { }

    //TODO backend call with confirm popup
    deleteFromSale(product: Material) {
        const index = this.productsToSale.indexOf(product);
        this.productsToSale.splice(index, 1);
        this.products.push(product);
    }

    addSaleProduct(product: Material) {
        if (!product.discountPrice) {
            this.openDiscountPriceDialog(product);
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem adja meg az akciós árát a ' + product.author + ':' + product.title + ' könyvhöz!'),
                MAT_ICON.error
            );
            this.dismissErrorFiveSeconds();
        } else {
            const index = this.products.indexOf(product);
            this.products.splice(index, 1);
            this.productsToSale.push(product);
        }
    }

    openDiscountPriceDialog(product: Material) {
        this._dialogService.openDialog(
            AddDiscountpriceDialogComponent,
            null,
            ((addDiscountPriceDialogResult: AddDiscountPriceDialogResult | undefined) => {
                this.addDiscountPrice(addDiscountPriceDialogResult?.discountPrice!, product)
            }
            )
        )
    }


    addDiscountPrice(discountPrice: number, product: Material) {
        const addDiscountPriceRequest: AddDiscountPriceRequest = {
            discountPrice: discountPrice,
            productId: product.id
        };

        this._apiRequestService
            .sendRequest<
                AddDiscountPriceRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, addDiscountPriceRequest, true, this.addDiscountPriceUrl)
            .subscribe(() => {
                const index = this.products.indexOf(product);
                this.products.splice(index, 1);
                this.productsToSale.push(product);
            });
    }

    createSaleForm() {
        this.saleForm = this._fb.group({
            onSaleEndDate: ['', [Validators.required]],
            onSaleStartDate: ['', [Validators.required]],
            onSaleName: ['', [Validators.required]]
        });
    }

    collectProductsToSaleData() {
        this.onSalePeriod = {
            name: this.saleForm?.controls['onSaleName'].value as string | undefined,
            startDate: this.saleForm?.controls['onSaleStartDate'].value as string | undefined,
            endDate: this.saleForm?.controls['onSaleEndDate'].value as string | undefined
        };
    }

    addOnSalePeriod() {
        this.collectProductsToSaleData();
        const productIds: number[] = this.productsToSale.map(p => p.id!);

        this.productSaleRequest = {
            onSalePeriod: this.onSalePeriod,
            productIdList: productIds
        };

        this._apiRequestService
            .sendRequest<
                AddOnSalePeriodRequest,
                AddOnSaleperiodResponse
            >(this.storeBaseUrl, this.productSaleRequest, true, this.addOnSalePeriodUrl, true)
            .subscribe(() => {
                this._router.navigateByUrl('/onsaleperiod');
            });
    }


    private dismissErrorFiveSeconds(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }
}
